module.exports = __webpack_public_path__ + "static/media/Gallery 6.2f8264bb.svg";